import './vaadin-upload-styles.js';
import '../../src/vaadin-upload.js';
